export const Marquee = ({ items }) => {
        if (!items?.length) return null;
        const doubled = [...items, ...items];
        return (
                <div className="border-y border-[var(--line-strong)] bg-[var(--bg-deep)] overflow-hidden">
                        <div className="py-2 overflow-hidden">
                                <div className="marquee-track">
                                        {doubled.map((it, i) => (
                                                <span
                                                        key={`${it.slug}-${i}`}
                                                        className="font-mono text-[11px] uppercase tracking-[0.3em] text-[var(--ink-soft)] flex items-center gap-3"
                                                >
                                                        <span
                                                                className="pulse-class"
                                                                style={{ color: "var(--deception)" }}
                                                        >
                                                                ●
                                                        </span>
                                                        <span className="text-[var(--ink)]">
                                                                {it.title}
                                                        </span>
                                                        <span className="text-[var(--ink-faint)]">
                                                                ÍNDICE {it.score}
                                                        </span>
                                                </span>
                                        ))}
                                </div>
                        </div>
                </div>
        );
};

export default Marquee;
